export default function AnimatedBackground() {
  return (
    <div className="pl-bg-shell" aria-hidden="true" data-testid="animated-background">
      <div className="pl-contour" />
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.18] mix-blend-screen pointer-events-none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 800"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="plgrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#27E6D1" />
            <stop offset="100%" stopColor="#B9FF2F" />
          </linearGradient>
        </defs>
        {[...Array(8)].map((_, i) => (
          <path
            key={i}
            d={`M0 ${300 + i * 30} C 360 ${260 + i * 18}, 720 ${360 + i * 22}, 1080 ${280 + i * 14} S 1440 ${320 + i * 18}, 1440 ${320 + i * 18}`}
            stroke="url(#plgrad)"
            strokeWidth="1"
            fill="none"
            opacity={0.5 - i * 0.05}
          />
        ))}
      </svg>
    </div>
  );
}
